
  import beauty_blemish_fix from "~/assets/images/index/icon/beauty_blemish-fix.svg";
  import beauty_clone from "~/assets/images/index/icon/beauty_clone.svg";
  import beauty_red_eye_removal from "~/assets/images/index/icon/beauty_red-eye-removal.svg";
  import beauty_reshape from "~/assets/images/index/icon/beauty_reshape.svg";
  import beauty_smoohing from "~/assets/images/index/icon/beauty_smoohing.svg";
  import beauty_teeth_whitening from "~/assets/images/index/icon/beauty_teeth-whitening.svg";
  import beauty_wrinkle_remover from "~/assets/images/index/icon/beauty_wrinkle-remover.svg";
  import collage_collage from "~/assets/images/index/icon/collage_collage.svg";
  import collage_segmentation from "~/assets/images/index/icon/collage_segmentation.svg";
  import collage_stitching from "~/assets/images/index/icon/collage_stitching.svg";
  import cutout_color_splash from "~/assets/images/index/icon/cutout_color-splash.svg";
  import cutout_double_exposure from "~/assets/images/index/icon/cutout_double-exposure.svg";
  import cutout_duotone from "~/assets/images/index/icon/cutout_duotone.svg";

  import ai_bg_blur from "~/assets/images/index/icon/ai_bg_blur.png";
  import ai_img2img from "~/assets/images/index/icon/ai_img2img.png";
  import ai_resize from "~/assets/images/index/icon/ai_resize.png";
  import ai_txt2img from "~/assets/images/index/icon/ai_txt2img.png";

  import edit_adjust from "~/assets/images/index/icon/edit_adjust.svg";
  import edit_background from "~/assets/images/index/icon/edit_background.svg";
  import edit_crop from "~/assets/images/index/icon/edit_crop.svg";
  import edit_curve from "~/assets/images/index/icon/edit_curve.svg";
  import edit_enhance from "~/assets/images/index/icon/edit_enhance.svg";
  import edit_focus from "~/assets/images/index/icon/edit_focus.svg";
  import edit_mosaic from "~/assets/images/index/icon/edit_mosaic.svg";
  import edit_text from "~/assets/images/index/icon/edit_text.svg";

  import edit_art_effects from "~/assets/images/index/icon/edit_art_effects.png"
  import edit_effects from "~/assets/images/index/icon/edit_effects.png"
  import edit_enhance_resolution from "~/assets/images/index/icon/edit_enhance_resolution.png"
  import edit_filters from "~/assets/images/index/icon/edit_filters.png"
  import edit_magic_remove from "~/assets/images/index/icon/edit_magic_remove.png"
  import edit_rotate from "~/assets/images/index/icon/edit_rotate.png"
  import edit_distort from "~/assets/images/index/icon/edit_distort.png"
  import edit_structure from "~/assets/images/index/icon/edit_structure.png"
  import edit_scenes from "~/assets/images/index/icon/edit_scenes.png"
  import edit_stickers from "~/assets/images/index/icon/edit_stickers.png"
  import edit_frames from "~/assets/images/index/icon/edit_frames.png"
  import cutout_bg_remover from "~/assets/images/index/icon/cutout_bg_remover.png"
  import cutout_profile_pics from "~/assets/images/index/icon/cutout_profile_pics.png"
  import beauty_ai_retouch from "~/assets/images/index/icon/beauty_ai_retouch.png"

  import jpgBannerBg from "~/assets/images/index/banner_bg.jpg";
  import pngBannerMobile from "~/assets/images/index/banner_mobile.png";
  import pngLogo from "~/assets/images/index/logo_fotor.png";
  import pngAppStore from "~/assets/images/index/app-store-en.png";
  import pngGooglePlay from "~/assets/images/index/google-play-badge-en.png";
  import { getBrowser, copyTextIntoClipboard, downloadAppFunc, createAdjustDeepLink } from "@Common";
  import DownloadAppShadow from "../components/common/DownloadAppShadow";
  import { setRem } from "@/utils/mobile.js";
  import OpenInBrowser from "@/components/common/OpenInBrowser.vue"

  export default {
    components: {
      DownloadAppShadow,
      OpenInBrowser
    },
    head () {
      return {
        title: this.shareInfo.title,
        meta: [
          { hid: "description", name: "description", content: this.shareInfo.description },

          { hid: "og:title", property: "og:title", content: this.shareInfo.title },
          { hid: "og:description", property: "og:description", id: "description", content: this.shareInfo.description },
          { hid: "og:image", property: "og:image", content: this.shareInfo.image },
          { hid: "og:url", property: "og:url", content: this.shareInfo.url },

          { hid: "twitter:title", name: "twitter:title", content: this.shareInfo.title },
          { hid: "twitter:description", name: "twitter:description", content: this.shareInfo.description },
          { hid: "twitter:image", name: "twitter:image", content: this.shareInfo.image },
          { hid: "twitter:card", name: "twitter:card", content: "photo" },
          { name: "robots", content: "noindex,nofollow" },
          { name: "googlebot", content: "noindex,nofollow" },
        ],
      };
    },
    props: {
      androidAppStoreImg: {
        type: String,
        default: pngGooglePlay,
      },
      iosAppStoreImg: {
        type: String,
        default: pngAppStore,
      },
    },
    data () {
      const i18n = this.$t("home");
      const { feature_items: featureItems } = i18n;
      return {
        pageData: {
          pageTitle: "Fotor: All-in-one Photo Editor",
          pageDesc: "For easier editing and better design. Join Fotor today!",
          head: {
            jpgBannerBg,
            pngBannerMobile,
            pngLogo,
            description: i18n.description,
          },
          card_list: {
            // https://dl.fotor.com/download/background_remover.mp4
            // playState: 0 未播放，1 正在播放

            1: {
              playState: 0,
              intersectionRatio: 0,
              isIntersecting: false,
              title: i18n.card_title.create_with_ai,
              type: "video",
              img: "https://dl.fotor.com/download/aigc.jpg",
              video: "https://dl.fotor.com/download/aigc.mp4"
            },
            2: {
              playState: 0,
              title: i18n.card_title.filters_effects,
              type: "video",
              img: "https://dl.fotor.com/download/filters_effects.jpg",
              video: "https://dl.fotor.com/download/filters_effects.mp4"
            },
            3: {
              playState: 0,
              intersectionRatio: 0,
              isIntersecting: false,
              title: i18n.card_title.bg_remover,
              type: "video",
              img: "https://dl.fotor.com/download/background_remover.jpg",
              video: "https://dl.fotor.com/download/background_remover.mp4"
            },
            4: {
              playState: 0,
              intersectionRatio: 0,
              isIntersecting: false,
              title: i18n.card_title.design_creative,
              type: "video",
              img: "https://dl.fotor.com/download/design.jpg",
              video: "https://dl.fotor.com/download/design.mp4"
            },
            5: {
              playState: 0,
              intersectionRatio: 0,
              isIntersecting: false,
              title: i18n.card_title.various_template,
              type: "video",
              img: "https://dl.fotor.com/download/template.jpg",
              video: "https://dl.fotor.com/download/template.mp4"
            }
          },

          features: [
            {
              id: 5,
              title: i18n.feature_title.ai_tools,
              items: [
                { title: featureItems.ai_img2img, img: ai_img2img },
                { title: featureItems.ai_txt2img, img: ai_txt2img },
                { title: featureItems.cutout_color_splash, img: cutout_color_splash },
                { title: featureItems.edit_magic_remove, img: edit_magic_remove },
                { title: featureItems.edit_enhance_resolution, img: edit_enhance_resolution },
                { title: featureItems.cutout_bg_remover, img: cutout_bg_remover },
                { title: featureItems.edit_art_effects, img: edit_art_effects },
                { title: featureItems.beauty_ai_retouch, img: beauty_ai_retouch },
                { title: featureItems.ai_bg_blur, img: ai_bg_blur },
              ]
            },
            {
              id: 1,
              title: i18n.feature_title.photo_editor,
              items: [
                { title: featureItems.edit_adjust, img: edit_adjust },
                { title: featureItems.edit_crop, img: edit_crop },
                { title: featureItems.edit_text, img: edit_text },
                { title: featureItems.edit_enhance, img: edit_enhance },
                { title: featureItems.edit_focus, img: edit_focus },
                { title: featureItems.edit_background, img: edit_background },
                { title: featureItems.edit_mosaic, img: edit_mosaic },
                { title: featureItems.edit_curve, img: edit_curve },
                { title: featureItems.edit_art_effects, img: edit_art_effects },
                { title: featureItems.edit_effects, img: edit_effects },
                { title: featureItems.edit_enhance_resolution, img: edit_enhance_resolution },
                { title: featureItems.edit_filters, img: edit_filters },
                { title: featureItems.edit_magic_remove, img: edit_magic_remove },
                { title: featureItems.edit_rotate, img: edit_rotate },
                { title: featureItems.edit_distort, img: edit_distort },
                { title: featureItems.edit_structure, img: edit_structure },
                { title: featureItems.edit_scenes, img: edit_scenes },
                { title: featureItems.edit_stickers, img: edit_stickers },
                { title: featureItems.edit_frames, img: edit_frames },
                { title: featureItems.ai_resize, img: ai_resize },
              ]
            },
            {
              id: 2,
              title: i18n.feature_title.collage_tool,
              items: [
                { title: featureItems.collage_collage, img: collage_collage },
                { title: featureItems.collage_stitching, img: collage_stitching },
                { title: featureItems.collage_segmentation, img: collage_segmentation }
              ]
            },
            {
              id: 3,
              title: i18n.feature_title.ai_cutout,
              items: [
                { title: featureItems.cutout_color_splash, img: cutout_color_splash },
                { title: featureItems.cutout_double_exposure, img: cutout_double_exposure },
                { title: featureItems.cutout_duotone, img: cutout_duotone },
                { title: featureItems.cutout_bg_remover, img: cutout_bg_remover },
                { title: featureItems.cutout_profile_pics, img: cutout_profile_pics },
                { title: featureItems.ai_bg_blur, img: ai_bg_blur },
              ]
            },
            {
              id: 4,
              title: i18n.feature_title.beauty,
              items: [
                { title: featureItems.beauty_smoohing, img: beauty_smoohing },
                { title: featureItems.beauty_wrinkle_remover, img: beauty_wrinkle_remover },
                { title: featureItems.beauty_blemish_fix, img: beauty_blemish_fix },
                { title: featureItems.beauty_reshape, img: beauty_reshape },
                { title: featureItems.beauty_clone, img: beauty_clone },
                { title: featureItems.beauty_red_eye_removal, img: beauty_red_eye_removal },
                { title: featureItems.beauty_teeth_whitening, img: beauty_teeth_whitening },
                { title: featureItems.beauty_ai_retouch, img: beauty_ai_retouch },
              ]
            }
          ],
          moreFeaturesTitle: i18n.moreFeaturesTitle,
        },

        shareInfo: {
          title: i18n.pageTitle,
          url: this.currentHost() + "",
          image: this.currentHost() + "/home/for_share.png",
          description: i18n.pageDesc,
        },

        browser: true,
        showShadow: false,
        videoObserver: null,
        currentPlayVideoId: null,
        btnDownloadObserver: null,
        showFixedBottom: false
      };
    },
    computed: {
      appStoreIcon () {
        return this.browser.isiOS ? this.$props.iosAppStoreImg : this.$props.androidAppStoreImg
      }
    },
    watch: {
      // 切换播放
      currentPlayVideoId (id, prevId) {
        let logmsg = [];
        let card_list = this.pageData.card_list;
        if (prevId && card_list[prevId] && card_list[prevId].target) {
          card_list[prevId].target.pause();
          logmsg.push("暂停", prevId);
        }
        if (id && card_list[id] && card_list[id].target) {
          this.videoPlay(id);
          logmsg.push("播放", id);
        }
        // console.log(...logmsg);
      }
    },
    created () {
      if (process.client) {
        this.browser = getBrowser();

        setRem(document, window, 520);
        this.videoObserver = new window.IntersectionObserver(this.videoSubscribe, {
          //threshold : 比如，[0, 0.5, 1]就表示当目标元素 0%、50%、100% 可见时，会触发回调函数。
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
        });

        this.btnDownloadObserver = new window.IntersectionObserver(this.btnDownloadSubscribe, {
          threshold: [0.2] //按钮完全看不到了在触发
        });

      }
    },
    mounted () {
      // head 不会被 i18n 触发响应式刷新，在这里手动触发
      this.shareInfo = {
        ...this.shareInfo
      }
      this.autoOpenAppStore();
      this.startVideoIntersectionObserve();
      this.startBtnDownloadObserve();
      // console.log("referrer",this.$route.query.referrer)
    },
    destroyed () {
      setRem(document, window, 1920);
      this.videoObserver.disconnect();
    },
    methods: {
      currentHost () {
        return process.env.NODE_ENV === "development" ? "http://test-nuls-mobile.fotor.com" : "http://nuls-mobile.fotor.com"
      },
      downloadApp () {
        //当路径中有 store_link 参数时，使用该参数作为应用商店链接打开【一般用于打开schema时的中间页使用指定的追踪链接作为下载链接】
        let store_link = this.$route.query.store_link;
        if (store_link) {
          location.href = store_link;
        }
        //如果是由桌面网页支付成功后扫码进来的，单独使用一个 adjust 链接【app新装后需要知道是由网页支付成功扫码后点击的下载】
        //链接格式如下：https://mobile.fotor.com/?utm_source=fotor-web&utm_content=upgrade_success_window&utm_campaign=web_to_app&_channel_track_key=6GCussC2
        else if (
          this.$route.query.utm_source && "utm_source" ||
          this.$route.query.utm_content && "upgrade_success_window" ||
          this.$route.query.utm_campaign && "web_to_app"
        ) {
          const schema = "fotor://" + location.search;
          location.href = createAdjustDeepLink({
            campaign: "web_to_app",
            adgroup: "upgrade_success_window",
            deep_link: schema
          });
        } else {
          downloadAppFunc(undefined, undefined, encodeURIComponent(this.$route.query.referrer));
          return;
        }
      },

      //是否进入页面就自动打开 app store
      autoOpenAppStore () {
        // console.log("autoOpenAppStore", this.$route.query.app_store, this.browser.isiOS)
        // 参数中有 app_store 则自动触发点击下载按钮
        if (!this.$route.query.app_store || this.$refs.refOpenInBrowser.needGuide) {
          return;
        }
        const id = setTimeout(() => {
          this.downloadApp()
        }, 200);

        document.addEventListener(
          "visibilitychange",
          function run () {
            document.removeEventListener("visibilitychange", run);
            clearTimeout(id);
            console.log('clearTimeout');
          },
        );

      },

      isShowCard (id) {
        return this.currentPlayVideoId === id;
      },
      videoPlay (id) {
        let card = this.pageData.card_list[id];
        let video = card.target;
        if (video && this.browser.isiOS) {
          video.currentTime = 0; //重置到0秒播放
          video.play(); //此处调用一次播放，用于解决ios video.readyState 的值永远 <=1的问题
        }
        let checkReadyStateInterval = 0;
        const checkReadyState = () => {
          if (video && this.isShowCard(id)) {
            // console.log("检测值", id, video.readyState);
            this.$set(card, "readyState", video.readyState);
            if (video.readyState === 4) {
              // console.log("------已经为4了", id);
              video.currentTime = 0; //重置到0秒播放
              video.play();
              setTimeout(() => {
                this.$set(card, "paly_state", true);
              }, 300);
            } else {
              this.$set(card, "paly_state", false);

              if (checkReadyStateInterval < 60000) {
                checkReadyStateInterval += 500;
                setTimeout(() => {
                  checkReadyState();
                }, 500);
              }
            }
          }
        };
        checkReadyState();
      },
      videoSubscribe (entitys) {
        let card_list = this.pageData.card_list;
        for (let i in entitys) {
          let id = entitys[i].target.getAttribute("data-id");
          card_list[id].isIntersecting = entitys[i].isIntersecting;
          if (entitys[i].isIntersecting) {
            card_list[id].intersectionRatio = entitys[i].intersectionRatio;
            card_list[id].target = entitys[i].target;
          } else {
            card_list[id].intersectionRatio = 0;
          }
        }
        let ids = Object.keys(card_list).filter(k => card_list[k].isIntersecting);
        // console.log("showVideos", ids);

        if (ids.length === 0) {
          this.currentPlayVideoId = null;
        } else if (ids.length === 1) {
          this.currentPlayVideoId = ids[0];
        } else if (ids.length === 2) {
          this.currentPlayVideoId =
            card_list[ids[0]].intersectionRatio > card_list[ids[1]].intersectionRatio
              ? ids[0]
              : ids[1];
        } else if (ids.length > 2) {
          this.currentPlayVideoId = ids[1];
          card_list[ids[1]].intersectionRatio = 1;
        }
      },

      btnDownloadSubscribe (entitys) {
        if (entitys[0] && entitys[0].isIntersecting) {
          this.showFixedBottom = false;
        } else {
          this.showFixedBottom = true;
        }
      },

      // 开始视频曝光检测
      startVideoIntersectionObserve () {
        let videos = this.$refs.videos;
        if (videos && videos.length) {
          for (let i in videos) {
            this.videoObserver.observe(videos[i]);
          }
        }
      },

      // 版头上的 应用商店按钮曝光检测
      startBtnDownloadObserve () {
        let btn_download = this.$refs.btn_download;
        if (btn_download) {
          this.btnDownloadObserver.observe(btn_download);
        }
      },
      btnDownload () {
        if (this.$refs.refOpenInBrowser.needGuide) {
          this.$refs.refOpenInBrowser.showMask();
          return;
        }
        const furl = this.$route.query.furl || "";
        if (furl) {
          copyTextIntoClipboard(furl);
        }
        this.downloadApp()
      }
    }
  };
